type SentryConfig = {
  SentryDSN: string;
  SentryRelease: string;
  TracesSampleRate: number;
};

const rawTracesSampleRate = import.meta.env.VITE_TRACES_SAMPLE_RATE;

export const sentryConfig: SentryConfig = {
  SentryDSN: import.meta.env.VITE_SENTRY_DSN,
  SentryRelease: import.meta.env.VITE_SENTRY_RELEASE,
  TracesSampleRate: rawTracesSampleRate ? +rawTracesSampleRate : 1.0,
};
